export default __webpack_public_path__ + "static/banner-two-shape10-348cfe41bebcb6d1fbe0043ea24ca082.png";